
// 2.

// import { useContext, useEffect, useState } from "react";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import Modal from "react-bootstrap/Modal";
// import "./UpdateComponent.css";
// import { AppThemeContext } from "../../context/AppThemeContext";
// import { BaseUrl } from "../../api/AxiosApi";
// import { groupListApi } from "../../api/Api";

// function UpdateComponent({ show, handleClose, userData, handleUpdate }) {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [formData, setFormData] = useState({
//         userId: "",
//         password: "",
//         userName: "",
//         email: "",
//         latitude: "",
//         longitude: "",
//         location: "",
//         commissionDate: "",
//         address: "",
//         groupId: ""

//     });

//     const [credentials] = useState({
//         User_ID: localStorage.getItem("LOGIN_ID") || "",
//         SKey: localStorage.getItem("SS_KEY") || "",
//     });

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);
//         try {
//             const res = await groupListApi(credentials);
//             if (res?.GROUP_LIST && Array.isArray(res.GROUP_LIST)) {
//                 setLogData(res.GROUP_LIST);

//             } else {
//                 setLogData([]);

//             }
//         } catch (err) {
//             console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [credentials.User_ID]);




//     useEffect(() => {
//         if (userData) {
//             setFormData({
//                 userId: userData.USER_ID || "",
//                 password: userData.PASSWORD || "",
//                 userName: userData.user || "",
//                 email: userData.Mail_ids || "",
//                 latitude: userData.LATITUDE || "",
//                 longitude: userData.LONGITUDE || "",
//                 location: userData.PLANT_LOCATION || "",
//                 commissionDate: formatDate(userData.PLANT_COMMISSIONED_DATE),
//                 address: userData.ADDRESS || "",
//                 groupId: userData.GROUP_ID || ""
//             });
//         }
//     }, [userData]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!formData.userId) {
//             console.error("User ID is missing. Cannot update.");
//             return;
//         }

//         try {
//             const queryParams = new URLSearchParams({
//                 User_Name: formData.userName,
//                 Password: formData.password,
//                 City: formData.location,
//                 Address: formData.address,
//                 Comm_Date: formData.commissionDate,
//                 Mail_ID: formData.email,
//                 Latitude: formData.latitude,
//                 Longitude: formData.longitude,
//                 SKey: "XYZ",
//                 GROUP_ID: formData.groupId
//             }).toString();

//             const formBody = new URLSearchParams({
//                 USER_ID: formData.userId, // Ensure correct USER_ID is sent
//             }).toString();

//             const finalUrl = `${BaseUrl}CMN_10_Update/uUSER_Det?${queryParams}`;
//             console.log("API URL:", finalUrl);

//             const response = await fetch(finalUrl, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/x-www-form-urlencoded",
//                 },
//                 body: formBody,
//             });

//             console.log("API Response:", response);

//             if (!response.ok) {
//                 throw new Error("Failed to update user");
//             }

//             const rawResponse = await response.text();
//             console.log("Raw API Response:", rawResponse);

//             const result = JSON.parse(rawResponse);
//             console.log("API Response Data:", result);

//             if (result.success) {
//                 handleUpdate(result); // Notify parent component
//                 handleClose(); // Close modal
//             }
//         } catch (error) {
//             console.error("Error updating user:", error);
//         }
//     };

//     // Function to convert '2024-Jan-05' to 'YYYY-MM-DD' format
//     const formatDate = (dateString) => {
//         if (!dateString) return "";

//         const months = {
//             Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
//             Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12",
//         };

//         const parts = dateString.split("-");
//         if (parts.length === 3) {
//             const year = parts[0];
//             const month = months[parts[1]];
//             const day = parts[2].padStart(2, "0");
//             return `${year}-${month}-${day}`;
//         }

//         return "";
//     };

//     return (
//         <Modal show={show} onHide={handleClose} centered>
//             <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
//                 <Modal.Title>Update User Details</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Form onSubmit={handleSubmit}>
//                     <div className="row">
//                         <div className="col-md-6">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>User ID</Form.Label>
//                                 <Form.Control type="text" name="userId" value={formData.userId} readOnly className="readonly-input" />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-6">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Password</Form.Label>
//                                 <Form.Control type="text" name="password" value={formData.password} onChange={handleChange} />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>User Name</Form.Label>
//                                 <Form.Control type="text" name="userName" value={formData.userName} onChange={handleChange} />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-6">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Plant Location</Form.Label>
//                                 <Form.Control type="text" name="location" value={formData.location} onChange={handleChange} />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-6">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Plant Commissioned Date</Form.Label>
//                                 <Form.Control type="date" name="commissionDate" value={formData.commissionDate} onChange={handleChange} />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-6">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Latitude</Form.Label>
//                                 <Form.Control type="text" name="latitude" value={formData.latitude} onChange={handleChange} />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-6">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Longitude</Form.Label>
//                                 <Form.Control type="text" name="longitude" value={formData.longitude} onChange={handleChange} />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Email</Form.Label>
//                                 <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Address</Form.Label>
//                                 <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} />
//                             </Form.Group>
//                         </div>


//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Group ID</Form.Label>
//                                 <Form.Select name="groupId" value={formData.groupId} onChange={handleChange}>
//                                     <option value={formData.groupId}>{formData.groupId}</option>
//                                     {logData.map((data, index) => (
//                                         <option key={index} value={data?.Group_id}>
//                                             {data?.Group_id}
//                                         </option>
//                                     ))}
//                                 </Form.Select>
//                             </Form.Group>
//                         </div>





//                     </div>

//                     <Modal.Footer>
//                         <Button onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
//                             Cancel
//                         </Button>
//                         <Button type="submit" style={{ backgroundColor: "red" }}>
//                             Update
//                         </Button>
//                     </Modal.Footer>
//                 </Form>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default UpdateComponent;

// 3.

import { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./UpdateComponent.css";
import { AppThemeContext } from "../../context/AppThemeContext";
import { BaseUrl } from "../../api/AxiosApi";
import { groupListApi } from "../../api/Api";

function UpdateComponent({ show, handleClose, userData, handleUpdate }) {
    const { PrimaryColor } = useContext(AppThemeContext);
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [formData, setFormData] = useState({
        userId: "",
        password: "",
        userName: "",
        email: "",
        latitude: "",
        longitude: "",
        location: "",
        commissionDate: "",
        address: "",
        groupId: ""  // ✅ Added groupId here
    });

    const [credentials] = useState({
        User_ID: localStorage.getItem("LOGIN_ID") || "",
        SKey: localStorage.getItem("SS_KEY") || "",
    });

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);
        try {
            const res = await groupListApi(credentials);
            if (res?.GROUP_LIST && Array.isArray(res.GROUP_LIST)) {
                setLogData(res.GROUP_LIST);
            } else {
                setLogData([]);
            }
        } catch (err) {
            console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials.User_ID]);

    useEffect(() => {
        if (userData) {
            setFormData({
                userId: userData.USER_ID || "",
                password: userData.PASSWORD || "",
                userName: userData.user || "",
                email: userData.Mail_ids || "",
                latitude: userData.LATITUDE || "",
                longitude: userData.LONGITUDE || "",
                location: userData.PLANT_LOCATION || "",
                commissionDate: formatDate(userData.PLANT_COMMISSIONED_DATE),
                address: userData.ADDRESS || "",
                groupId: userData.GROUP_ID || ""  // ✅ Setting groupId here
            });
        }
    }, [userData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.userId) {
            console.error("User ID is missing. Cannot update.");
            return;
        }

        try {
            const queryParams = new URLSearchParams({
                User_Name: formData.userName,
                Password: formData.password,
                City: formData.location,
                Address: formData.address,
                Comm_Date: formData.commissionDate,
                Mail_ID: formData.email,
                Latitude: formData.latitude,
                Longitude: formData.longitude,
                SKey: "XYZ"
            }).toString();

        
            const formBody = new URLSearchParams({
                USER_ID: formData.userId,
                GROUP_ID: formData.groupId,
                TYPE_ID: "U"
            }).toString();

            const finalUrl = `${BaseUrl}CMN_10_Update/uUSER_Det?${queryParams}`;

            console.log("API URL:", finalUrl);
            console.log("Request Body:", formBody);

            const response = await fetch(finalUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: formBody,
            });

            if (!response.ok) {
                throw new Error("Failed to update user");
            }

            const rawResponse = await response.text();
            console.log("Raw API Response:", rawResponse);

            const result = JSON.parse(rawResponse);
            console.log("API Response Data:", result);

            if (result.success) {
                handleUpdate(result);
                handleClose();
            }
        } catch (error) {
            console.error("Error updating user:", error);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const months = {
            Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
            Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12",
        };
        const parts = dateString.split("-");
        if (parts.length === 3) {
            return `${parts[0]}-${months[parts[1]]}-${parts[2].padStart(2, "0")}`;
        }
        return "";
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
                <Modal.Title>Update User Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <Form.Group className="mb-1">
                                <Form.Label>User ID</Form.Label>
                                <Form.Control type="text" name="userId" value={formData.userId} readOnly className="readonly-input" />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-1">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="text" name="password" value={formData.password} onChange={handleChange} />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>User Name</Form.Label>
                                <Form.Control type="text" name="userName" value={formData.userName} onChange={handleChange} />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-1">
                                <Form.Label>Plant Location</Form.Label>
                                <Form.Control type="text" name="location" value={formData.location} onChange={handleChange} />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-1">
                                <Form.Label>Plant Commissioned Date</Form.Label>
                                <Form.Control type="date" name="commissionDate" value={formData.commissionDate} onChange={handleChange} />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-1">
                                <Form.Label>Latitude</Form.Label>
                                <Form.Control type="text" name="latitude" value={formData.latitude} onChange={handleChange} />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-1">
                                <Form.Label>Longitude</Form.Label>
                                <Form.Control type="text" name="longitude" value={formData.longitude} onChange={handleChange} />
                            </Form.Group>
                        </div>

                        {/* <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="text" name="email" value={formData.email} onChange={handleChange}
                                    style={{
                                        height: '100px',
                                        fontSize: '16px',
                                        width: '100%',
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap'
                                    }}
                                />
                            </Form.Group>
                        </div> */}

                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    style={{
                                        minHeight: '80px',
                                        width: '100%',
                                        overflow: 'auto',
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                        resize: 'vertical',
                                        fontSize: '14px', // optional: improves appearance
                                        padding: '10px'   // optional: for better spacing
                                    }}
                                />
                            </Form.Group>
                        </div>





                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>Address</Form.Label>
                                <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>Group ID</Form.Label>
                                <Form.Select name="groupId" value={formData.groupId} onChange={handleChange}>
                                    <option value="">Select Group</option>
                                    {logData.map((data, index) => (
                                        <option key={index} value={data?.Group_id}>
                                            {data?.Group_id}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </div>

                    </div>

                    <Modal.Footer>
                        <Button onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
                            Cancel
                        </Button>
                        <Button type="submit" style={{ backgroundColor: "red" }}>
                            Update
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default UpdateComponent;
